import { useState } from "react";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";

const Sitemap = () => {
    const [loadingSitemap, setLoadingSitemap] = useState(false);

    const generateSitemap = async () => {
        setLoadingSitemap(true);
        try {
            const res = await axiosInstance.get("/sitemap/createSiteMap");
            toast.success(res.data?.message || "Sitemap generated successfully");
        } catch (err) {
            toast.error(err?.response?.data?.message || "Failed to generate sitemap");
        } finally {
            setLoadingSitemap(false);
        }
    };

    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Sitemap", path: "/sitemap" },
    ];

    return (
        <div className="content-wrapper">
            <div className="page-header">
                <h3 className="page-title">Sitemap</h3>
                <Breadcrumb items={breadcrumbdata} />
            </div>

            <div className="row g-4">
                <div className="col-md-12">
                    <div className="card shadow-sm">
                        <div className="card-body d-flex justify-content-between align-items-center">
                            <div>
                                <h3 className="mb-1">Generate Sitemap</h3>
                            </div>
                            <button
                                className="btn btn-primary"
                                onClick={generateSitemap}
                                disabled={loadingSitemap}
                            >
                                {loadingSitemap ? "Generating..." : "Generate Sitemap"}
                            </button>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
        </div>
    );
};

export default Sitemap;